/**
 * Outputs duration of given fractional hours in the format of "Xh YYm"
 * Examples: "8h 30m", "8h 00m", "0h 45m"
 * When `areLeadingZeroesAllowed` is `false`, it returns "45m", "7m", "1m"
 * Returns "0h 00m" or "0m" for zero or negative durations
 */
export function formatHoursDurationCompact(
  durationInHours: number,
  options?: { areLeadingZeroesAllowed?: boolean }
): string {
  const { areLeadingZeroesAllowed = true } = options ?? {};
  const durationInMinutes = Math.round(durationInHours * 60);

  if (durationInMinutes <= 0) {
    return areLeadingZeroesAllowed ? "0h 00m" : "0m";
  }

  const hours = Math.floor(durationInMinutes / 60);
  const hoursString = areLeadingZeroesAllowed || hours > 0 ? `${hours}h ` : "";
  const minutes = durationInMinutes % 60;

  // Ensure minutes are always two digits
  const paddedMinutes =
    areLeadingZeroesAllowed || hours > 0 ? minutes.toString().padStart(2, "0") : minutes;

  return `${hoursString}${paddedMinutes}m`;
}
